// App.js
import React, { useState } from "react";
import Sidebar from "./Sidebar";

const Button = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const openSidebarBtnStyle = {
    position: "fixed",
    fontSize: "18px",
    backgroundColor: "#111",
    color: "white",
    border: "none",
    padding: "10px 20px",
    cursor: "pointer",
  };

  return (
    <div>
      <button
        className="mt-5"
        onClick={toggleSidebar}
        style={openSidebarBtnStyle}
      >
        Open Sidebar
      </button>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    </div>
  );
};

export default Button;
